export const METRIC_TYPES = Object.freeze({
  BUCKET: 'bucket',
  COUNTER: 'counter',
  TIMER: 'timer'
})

export const LOAD_TIME_MEASURE_BUCKETS = ['500', '800', '1000', '1200', '1500', '2000', '3000', '5000']
export const DEFAULT_TIMING_BUCKETS = ['500', '800', '1000', '1200', '1500', '2000', '3000', '5000', '6000', '7000', '8000', '9000', '10000', '11000', '12000']
